module.exports = __webpack_public_path__ + "img/my1.b824f2b2.png";